import { Controller } from "@hotwired/stimulus";
import "bootstrap-tagsinput";

export default class TagsInputController extends Controller {
  connect() {
    $(this.element).tagsinput({
      trimValue: true
    });

    $(this.element).on("beforeItemAdd", (event) => {
      const newTag = event.item.trim().toLowerCase();

      const existingTags = $(this.element)
        .tagsinput("items")
        .map(tag => tag.trim().toLowerCase());

      if (existingTags.includes(newTag)) {
        event.cancel = true;
      }
    });

    $(this.element).on("itemAdded itemRemoved", () => {
      this.updatePlaceholder();
    });

    this.updatePlaceholder();
  }

  updatePlaceholder() {
    const tagsInput = $(this.element);
    const input = tagsInput.siblings(".bootstrap-tagsinput").find("input");

    input.attr(
      "placeholder",
      tagsInput.tagsinput("items").length > 0 ? "" : "Enter Tags"
    );
  }
}
